export const GUEST_THEME_QUERY_PARAM = 't'
